import { render, staticRenderFns } from "./WaitingPayment.vue?vue&type=template&id=67aedadc&scoped=true"
import script from "./WaitingPayment.vue?vue&type=script&lang=js"
export * from "./WaitingPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67aedadc",
  null
  
)

export default component.exports